"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtiIntegrationZendeskService = void 0;
var http_service_1 = require("./http.service");
var jwt_extractor_service_1 = require("./jwt-extractor.service");
var OtiIntegrationZendeskService = /** @class */ (function () {
    function OtiIntegrationZendeskService() {
        this.zendeskDomain = 'https://clarivate8549.zendesk.com';
        this.zendeskAlreadyAuthenticated = false;
        this.http = new http_service_1.HttpService();
        this.jwtExtractorService = new jwt_extractor_service_1.JwtExtractorService();
    }
    OtiIntegrationZendeskService.prototype.configure = function (_a) {
        var _b;
        var options = _a.options;
        this.zendeskKey = options.zendesk_key;
        this.zendeskAppName = options.zendesk_appName;
        this.zendeskLibraryUrl = options.zendesk_url || 'https://static.zdassets.com/ekr/snippet.js';
        this.zendeskRedirectToHelpCenter = options.zendesk_redirect_to_help_center === true;
        this.zendeskShowOriginalArticleLink = options.zendesk_hide_article_link !== true;
        this.zendeskWidgetHorizontalPosition = options.zendesk_position;
        this.zendeskEnvironment = options.zendesk_environment;
        this.zendeskAccessDomain = (_b = options.zendesk_access_domain) !== null && _b !== void 0 ? _b : '';
    };
    OtiIntegrationZendeskService.prototype.consumeAuthCallback = function (jwt) {
        if (this.zendeskAuthCallback) {
            this.zendeskAuthCallback(jwt);
            this.zendeskAuthCallback = undefined;
        }
    };
    OtiIntegrationZendeskService.prototype.getAuthenticatedAccessUrl = function (appJwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var jwtResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get("".concat(this.zendeskAccessDomain, "/zendesk-access/jwt/hc?appName=").concat(this.zendeskAppName, "&env=").concat(this.zendeskEnvironment || ''), appJwtToken, this.zendeskAccessDomain !== '')];
                    case 1:
                        jwtResponse = _a.sent();
                        return [2 /*return*/, "".concat(this.zendeskDomain, "/access/jwt?jwt=").concat(jwtResponse.jwt, "&return_to=").concat(encodeURIComponent(this.zendeskHelpCenterUrl || ''))];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.getAppInfo = function (appJwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get("".concat(this.zendeskAccessDomain, "/zendesk-access/app-info?appName=").concat(this.zendeskAppName, "&env=").concat(this.zendeskEnvironment || ''), appJwtToken, this.zendeskAccessDomain !== '')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.getHelpCenterUrl = function (appJwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.zendeskHelpCenterUrl) return [3 /*break*/, 1];
                        url = this.zendeskHelpCenterUrl;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getAppInfo(appJwtToken)];
                    case 2:
                        url = (_a.sent()).helpCenterUrl;
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.zendeskHelpCenterUrl = url];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.getWebWidgetJWT = function (appJwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var jwt, jwtResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.zendeskWebWidgetJWT) return [3 /*break*/, 1];
                        jwt = this.zendeskWebWidgetJWT;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.http.get("".concat(this.zendeskAccessDomain, "/zendesk-access/jwt/widget?appName=").concat(this.zendeskAppName, "&env=").concat(this.zendeskEnvironment || ''), appJwtToken, this.zendeskAccessDomain !== '')];
                    case 2:
                        jwtResponse = _a.sent();
                        jwt = jwtResponse.jwt;
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.zendeskWebWidgetJWT = jwt];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.executeOnZendeskLibrary = function (name, method, params) {
        var lib = window.zE;
        if (typeof lib === 'function') {
            return lib(name, method, params);
        }
        else {
            console.warn("Zendesk not loaded for executing ".concat(name, ".").concat(method));
        }
    };
    OtiIntegrationZendeskService.prototype.getAsynchronousHTMLElement = function (container, selector) {
        var _findElement = function (stack, callback) {
            var zendeskWidgetIFrame = container.querySelector(selector);
            if (zendeskWidgetIFrame) {
                callback(zendeskWidgetIFrame);
            }
            else if (stack > 100) {
                callback(null);
            }
            else {
                setTimeout(function () { return _findElement(stack + 1, callback); }, 100);
            }
        };
        return new Promise(function (resolve, reject) {
            _findElement(0, function (zendeskWidgetIFrame) {
                if (zendeskWidgetIFrame) {
                    resolve(zendeskWidgetIFrame);
                }
                else {
                    reject(new Error("Unable to find ".concat(selector)));
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.getAuthenticatedHelpCenterUrl = function (accessUrl, url) {
        return "".concat(accessUrl.replace(/[?&]return_to=[^?&]*/, ''), "&return_to=").concat(encodeURIComponent(url));
    };
    OtiIntegrationZendeskService.prototype.replaceByAuthUrls = function (accessUrl, urlPattern, zendeskHelpCenterContentEl) {
        var _this = this;
        if (!this.zendeskAlreadyAuthenticated) {
            var aLinks = zendeskHelpCenterContentEl.querySelectorAll('a:not([data-testid])');
            aLinks.forEach(function (aEl) {
                var url = aEl.getAttribute('href');
                if (url && (url === null || url === void 0 ? void 0 : url.startsWith(urlPattern))) {
                    aEl.addEventListener('click', function (event) {
                        if (!_this.zendeskAlreadyAuthenticated) {
                            event.preventDefault();
                            _this.zendeskAlreadyAuthenticated = true;
                            var authUrl = _this.getAuthenticatedHelpCenterUrl(accessUrl, url);
                            window.open(authUrl, '_blank');
                        }
                    });
                }
            });
        }
    };
    OtiIntegrationZendeskService.prototype.replaceHelpCenterAuthLinks = function (accessUrl, urlPattern) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var zendeskWidgetIFrame, zendeskWidgetContainer;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAsynchronousHTMLElement(document.body, '#webWidget')];
                    case 1:
                        zendeskWidgetIFrame = _b.sent();
                        zendeskWidgetContainer = (_a = zendeskWidgetIFrame.contentWindow) === null || _a === void 0 ? void 0 : _a.document.body;
                        if (zendeskWidgetContainer && !zendeskWidgetContainer.getAttribute('oti-snippet')) {
                            zendeskWidgetContainer.setAttribute('oti-snippet', 'yes');
                            this.searchZendeskLinks(accessUrl, urlPattern, zendeskWidgetContainer);
                            zendeskWidgetContainer.addEventListener('click', function () { return _this.searchZendeskLinks(accessUrl, urlPattern, zendeskWidgetContainer); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.handleFurtherReRender = function (targetNode, callback) {
        var observer = new MutationObserver(function (mutationList) {
            for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                var mutation = mutationList_1[_i];
                if (mutation.type === "childList") {
                    callback();
                }
            }
        });
        observer.observe(targetNode, { childList: true, subtree: true });
    };
    OtiIntegrationZendeskService.prototype.prepareHelpCenter = function (appJwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, _a, accessUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getWebWidgetJWT(appJwtToken)];
                    case 1:
                        tokens = _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.getHelpCenterUrl(appJwtToken)];
                    case 2:
                        _a.zendeskHelpCenterUrl = _b.sent();
                        if (!tokens) return [3 /*break*/, 5];
                        this.consumeAuthCallback(tokens);
                        if (!this.zendeskHelpCenterUrl) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getAuthenticatedAccessUrl(appJwtToken)];
                    case 3:
                        accessUrl = _b.sent();
                        if (!accessUrl) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.replaceHelpCenterAuthLinks(accessUrl, this.zendeskHelpCenterUrl)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.redirectToHelpCenter = function (appJwtToken, helpCenterUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var accessUrl, targetUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthenticatedAccessUrl(appJwtToken)];
                    case 1:
                        accessUrl = _a.sent();
                        targetUrl = helpCenterUrl || this.zendeskHelpCenterUrl;
                        if (accessUrl && targetUrl) {
                            window.open(this.getAuthenticatedHelpCenterUrl(accessUrl, targetUrl));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.searchZendeskLinks = function (accessUrl, urlPattern, zendeskWidgetContainerEl) {
        return __awaiter(this, void 0, void 0, function () {
            var zendeskHelpCenterContent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAsynchronousHTMLElement(zendeskWidgetContainerEl, 'main')];
                    case 1:
                        zendeskHelpCenterContent = _a.sent();
                        if (!zendeskHelpCenterContent.getAttribute('oti-snippet')) {
                            zendeskHelpCenterContent.setAttribute('oti-snippet', 'yes');
                            this.replaceByAuthUrls(accessUrl, urlPattern, zendeskHelpCenterContent);
                            this.handleFurtherReRender(zendeskHelpCenterContent, function () { return _this.replaceByAuthUrls(accessUrl, urlPattern, zendeskHelpCenterContent); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.setUpPosition = function () {
        if (this.zendeskWidgetHorizontalPosition) {
            this.executeOnZendeskLibrary('webWidget', 'updateSettings', {
                webWidget: {
                    position: { horizontal: this.zendeskWidgetHorizontalPosition },
                }
            });
        }
    };
    OtiIntegrationZendeskService.prototype.whenFunctionLibraryIsReady = function () {
        var _this = this;
        this.executeOnZendeskLibrary('webWidget', 'hide');
        this.executeOnZendeskLibrary('webWidget:on', 'open', function () { return __awaiter(_this, void 0, void 0, function () {
            var appJwtToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setUpPosition();
                        return [4 /*yield*/, this.extractApplicationToken()];
                    case 1:
                        appJwtToken = _a.sent();
                        if (!this.zendeskRedirectToHelpCenter) return [3 /*break*/, 3];
                        this.executeOnZendeskLibrary('webWidget', 'close');
                        return [4 /*yield*/, this.redirectToHelpCenter(appJwtToken)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.prepareHelpCenter(appJwtToken)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        this.executeOnZendeskLibrary('webWidget:on', 'close', function () { return _this.executeOnZendeskLibrary('webWidget', 'helpCenter:reauthenticate'); });
    };
    OtiIntegrationZendeskService.prototype.enabled = function () {
        return this.zendeskKey !== undefined;
    };
    OtiIntegrationZendeskService.prototype.getPlatformTokenStorageAttributes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get("".concat(this.zendeskAccessDomain, "/zendesk-access/app-storage?appName=").concat(this.zendeskAppName, "&env=").concat(this.zendeskEnvironment || ''), undefined, this.zendeskAccessDomain !== '')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, {
                                cookies: response.cookies,
                                tokenName: response.storageTokenName,
                                tokenAttr: response.storageTokenAttr
                            }];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.extractApplicationToken = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, cookies, tokenName, tokenAttr, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        if (!!this.zendeskAppSettings) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getPlatformTokenStorageAttributes()];
                    case 1:
                        _b = _c.sent(), cookies = _b.cookies, tokenName = _b.tokenName, tokenAttr = _b.tokenAttr;
                        if (!cookies && !tokenName) {
                            throw new Error('Missing zendesk platform token identifier');
                        }
                        this.zendeskAppSettings = { cookies: cookies, token: tokenName ? this.jwtExtractorService.extract(tokenName, tokenAttr) : undefined };
                        _c.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, (_a = this.zendeskAppSettings) === null || _a === void 0 ? void 0 : _a.token];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.goToZendeskHelpCenter = function (helpCenterUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var jwtToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.extractApplicationToken()];
                    case 1:
                        jwtToken = _a.sent();
                        return [2 /*return*/, this.redirectToHelpCenter(jwtToken, helpCenterUrl)];
                }
            });
        });
    };
    OtiIntegrationZendeskService.prototype.init = function () {
        var _this = this;
        if (!this.zendeskKey) {
            throw new Error('Missing zendesk key');
        }
        if (!this.zendeskAppName) {
            throw new Error('Missing zendesk appName');
        }
        window.zESettings = {
            webWidget: {
                helpCenter: {
                    originalArticleButton: this.zendeskShowOriginalArticleLink
                },
                authenticate: {
                    jwtFn: function (callback) {
                        _this.zendeskAuthCallback = callback;
                    }
                }
            }
        };
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('id', 'ze-snippet');
        script.setAttribute('src', "".concat(this.zendeskLibraryUrl, "?key=").concat(this.zendeskKey));
        var headerEl = document.getElementsByTagName('head')[0];
        if (headerEl) {
            script.addEventListener('load', function () { return _this.whenFunctionLibraryIsReady(); });
            headerEl.appendChild(script);
        }
    };
    return OtiIntegrationZendeskService;
}());
exports.OtiIntegrationZendeskService = OtiIntegrationZendeskService;
